<template>
    <div class="overflow-y-auto max-h-96 pb-5">
        <table class="w-full">
            <thead class="bg-lightGray h-10 sticky top-0">
                <tr class="font-bold">
                    <td class="pl-2">{{ $t('product.name') }}</td>
                    <td class="d-none d-sm-table-cell">{{ $t('supplier.title') }}</td>
                    <td>{{ $t('product.datePurchase') }}</td>
                    <td>{{ $t('product.pricePurchase') }}</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in productPurchases" :key="index" class="h-10 text-main font-bold">
                    <td class="pl-2">
                        {{ item.product.name }}
                    </td>
                    <td class="d-none d-sm-block">
                        <div>
                            <div v-if="item.supplier === null || item.supplier === undefined">

                            </div>
                            <div v-else-if="item.supplier.isCompany">
                                {{ item.supplier.supplierCompany.name }}
                            </div>
                            <div v-else>
                                {{ item.supplier.person.givenName }}
                                {{ item.supplier.person.familyName }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div v-if="item.createdAt !== undefined">
                            {{ dateTimeFormat(item.createdAt) }}
                        </div>
                    </td>
                    <td>
                        <div v-if="item.pricePerUnit !== undefined || item.currency !== undefined">
                            {{ showCurrencyById(item.currency.id, item.pricePerUnit) }}
                        </div>
                    </td>
                </tr>
                <tr class="h-10">
                    <td class="font-bold pl-2" colspan="1">{{ $t('sale.sum') }}</td>
                    <td class="font-bold">{{ showCurrencyByIdWithoutSymbol(this.getCurrencyByShortName(currentCurrencyShortName).id, totalPrice) }}</td>
                    <td class="d-none d-sm-block"></td>
                    <td>
                        <select
                            class="border-0 cursor-pointer focus:ring-0 bg-white w-24 focus:outline-none"
                            @change="exchangeCurrency"
                            v-model="currentCurrencyShortName">
                            <option value="UZS">UZS</option>
                            <option value="USD">USD</option>
                            <option value="RUB">RUB</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";

export default {
    name: "ProductPurchasesListTable",
    mixins: [dateFormattingMixin, currencyFormatMixin, currencyRateMixin],
    props: {
        productPurchases: {
            type: Array,
            required: true
        },
        isNeedRefresh: {
            type: Boolean,
            required: true
        },
        isReady: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            totalPrice: 0,
        }
    },
    methods: {
        exchangeCurrency() {
            this.calculateTotalPrice()
        },
        calculateTotalPrice() {
            switch (this.currentCurrencyShortName) {
                case 'USD': {
                    return this.totalPrice = this.showCurrencyById(null, this.converterValuteToUsd())
                }

                case 'RUB': {
                    return this.totalPrice = this.showCurrencyById(null, this.converterValuteToRub())
                }

                case 'UZS': {
                    return this.totalPrice = this.showCurrencyById(null, this.converterValuteToUzs())
                }
            }
        },
        converterValuteToUzs() {
            let inUSD = 0.0
            let inRUB = 0.0
            let inUZS = 0.0

            for (let productPurchase of this.productPurchases) {

                if (productPurchase.currency.id === this.getCurrencyByShortName('USD').id) {
                    inUSD += parseFloat(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }

                if (productPurchase.currency.id === this.getCurrencyByShortName('RUB').id) {
                    inRUB += parseFloat(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }

                if (productPurchase.currency.id === this.getCurrencyByShortName('UZS').id) {
                    inUZS += parseInt(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }
            }

            return inUZS + this.calculateAmountByBaseCurrency(inUSD, "USD", "UZS") + this.calculateAmountByBaseCurrency(inRUB, "RUB", "UZS")
        },
        converterValuteToRub() {
            let inUSD = 0.0
            let inRUB = 0.0
            let inUZS = 0.0

            for (let productPurchase of this.productPurchases) {
                if (productPurchase.currency.id === this.getCurrencyByShortName('USD').id) {
                    inUSD += parseFloat(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }

                if (productPurchase.currency.id === this.getCurrencyByShortName('RUB').id) {
                    inRUB += parseFloat(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }

                if (productPurchase.currency.id === this.getCurrencyByShortName('UZS').id) {
                    inUZS += parseInt(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }
            }

            return inRUB + this.calculateAmountByBaseCurrency(inUZS, "UZS", "RUB") + this.calculateAmountByBaseCurrency(inUSD, "USD", "RUB")
        },
        converterValuteToUsd() {
            let inUSD = 0.0
            let inUZS = 0.0
            let inRUB = 0.0

            for (let productPurchase of this.productPurchases) {
                if (productPurchase.currency.id === this.getCurrencyByShortName('USD').id) {
                    inUSD += parseFloat(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }

                if (productPurchase.currency.id === this.getCurrencyByShortName('RUB').id) {
                    inRUB += parseFloat(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }

                if (productPurchase.currency.id === this.getCurrencyByShortName('UZS').id) {
                    inUZS += parseInt(productPurchase.pricePerUnit) * (productPurchase.quantity + productPurchase.addQuantity)
                }
            }

            return inUSD + this.calculateAmountByBaseCurrency(inUZS, "UZS", "USD") + this.calculateAmountByBaseCurrency(inRUB, "RUB", "USD")
        },
    },
    watch: {
        'productPurchases'() {
            setTimeout( () => this.calculateTotalPrice(), 500)
        },
        'isNeedRefresh'() {
            setTimeout(() => this.calculateTotalPrice(), 500)
        },
        'isReady'() {
            this.calculateTotalPrice()
        }
    },
    mounted() {
        setTimeout(() => this.calculateTotalPrice(), 500)
    }

}
</script>

<style scoped>

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

::-webkit-scrollbar {
    width: 2px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #6539B2;
}


</style>
